module.exports = __webpack_public_path__ + "static/media/cardhub-logo.bdcbf04d.svg";